export default function() {
    const selector = '.o-dropdown';
    const dropdowns = document.querySelectorAll(selector);

    dropdowns.forEach(d => {
        const content = d.querySelector(selector + '__content');

        d.onclick = () => {
            content.classList.toggle('show')
        }
    })
}